import { NgModule } from '@angular/core';
import { RouteAlgoAdminComponent } from './route-algo-admin.component';
import { RouterModule, Routes } from '@angular/router';
import { VmeCommonModule } from '../../vme-common.module';
import { VmeDirectivesModule } from '../../vme-directives.module';
import { VmePipesModule } from '../../vme-pipes.module';
import { VMEComponentsModule } from '../../vme-components.module';
import { RouteAlgoAdminOrganisationManagerComponent } from './route-algo-admin-organisation-manager/route-algo-admin-organisation-manager.component';
import { NgClass, NgIf } from '@angular/common';
import {
  ButtonModule,
  CalendarModule,
  DropdownModule,
  InputTextModule,
  MultiSelectModule,
  SharedModule,
  TableModule,
} from 'primeng';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

const routes: Routes = [
  {
    path: '',
    component: RouteAlgoAdminComponent,
    data: { title: 'Route Algo Admin' },
  },
];

@NgModule({
  imports: [
    RouterModule.forChild(routes),
    NgIf,
    SharedModule,
    TableModule,
    ButtonModule,
    CalendarModule,
    DropdownModule,
    FormsModule,
    MultiSelectModule,
    ReactiveFormsModule,
    InputTextModule,
    NgClass,
  ],
  exports: [RouterModule, RouteAlgoAdminOrganisationManagerComponent],
  declarations: [RouteAlgoAdminOrganisationManagerComponent],
})
export class RouteAlgoAdminRoutingModule {}

@NgModule({
  declarations: [RouteAlgoAdminComponent],
  imports: [
    RouteAlgoAdminRoutingModule,
    VmeCommonModule,
    VmeDirectivesModule,
    VmePipesModule,
    VMEComponentsModule,
  ],
})
export class RouteAlgoAdminModule {}
